import type { Command } from '@/types';

/** Keeps a filtered command subset in the order established by its source surface. */
export const orderCommandsBySource = (commands: Command[], sourceCommands: Command[]): Command[] => {
    const sourceOrder = new Map(sourceCommands.map((command, index) => [command.id, index]));

    return [...commands].sort(
        (left, right) =>
            (sourceOrder.get(left.id) ?? Number.MAX_SAFE_INTEGER) -
            (sourceOrder.get(right.id) ?? Number.MAX_SAFE_INTEGER),
    );
};
